import { useState } from "react";

const CALENDAR_URL =
  "https://www.landeditore.it/calendario-dellavvento-land-editore-jane-austen-edition/";

export default function RewardBox() {
  const [copied, setCopied] = useState(false);

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText("PEMBERLEY10");
    } catch {
      const ta = document.createElement("textarea");
      ta.value = "PEMBERLEY10"; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy"); } catch {}
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2600);
  };

  return (
    <div className="reward-box" data-testid="reward-box">
      <div className="reward-head">UN REGALO PER VOI</div>
      <p className="reward-desc">
        Ricevete <b>10 €</b> di sconto sul Calendario dell'Avvento Jane Austen Edition.
      </p>
      <div className="reward-code" data-testid="reward-code">PEMBERLEY10</div>
      <div className="reward-actions">
        <button className="reward-btn copy" onClick={copyCode} data-testid="copy-code-btn">
          {copied ? "Codice copiato!" : "COPIA IL CODICE"}
        </button>
        <a
          className="reward-btn discover"
          href={CALENDAR_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="discover-calendar-btn"
        >
          SCOPRI IL CALENDARIO
        </a>
      </div>
      <p className="reward-note">
        Codice utilizzabile una sola volta per cliente e non cumulabile con altre promozioni.
      </p>
    </div>
  );
}
